import React from 'react';

const BrandBanner__2 = () => {
    return (
        <div className="brand-banner--2-wrapper xmt-10 xmb-15 xmy-lg-22">
            <div className="container">
                <div className="brand-box">
                    <div className="swiper brand-banner-swiper">
                        <div className="swiper-wrapper">
                            <div className="swiper-slide">
                                <a href="#" className="item--1">
                                    <img src="./assets/sample-image/ppp.png" alt="image"/>
                                </a>
                            </div>
                            <div className="swiper-slide">
                                <a href="#" className="item--2">
                                    <img src="./assets/sample-image/cfckd.png" alt="image"/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandBanner__2;
